module.exports = __webpack_public_path__ + "img/style_model_preview_683.01f9b1f9.jpg";